"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BicycleFacilityRequestIcon = BicycleFacilityRequestIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function BicycleFacilityRequestIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_17415)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#FFF5D0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.0724 23.7727C29.6533 23.7732 30.1239 24.2447 30.1239 24.8258V27.3583H32.9445C33.5256 27.3586 33.9976 27.8302 33.9976 28.4114C33.9971 28.9922 33.5253 29.4625 32.9445 29.4628H30.1239V32.2802C30.1239 32.8612 29.6533 33.3327 29.0724 33.3333C28.4911 33.3333 28.0194 32.8615 28.0194 32.2802V29.4628H25.4868L25.2752 29.4417C24.7957 29.3436 24.4342 28.9198 24.4338 28.4114C24.4338 27.9026 24.7954 27.4775 25.2752 27.3795L25.4868 27.3583H28.0194V24.8258C28.0194 24.2444 28.4911 23.7727 29.0724 23.7727Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.38656 8.33325C9.96771 8.33348 10.438 8.8051 10.438 9.38631V29.7362C10.438 30.3175 9.96771 30.7891 9.38656 30.7893C8.8052 30.7893 8.3335 30.3176 8.3335 29.7362V9.38631C8.3335 8.80496 8.8052 8.33325 9.38656 8.33325Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.2108 25.1757C19.7919 25.1759 20.2622 25.6476 20.2622 26.2288V29.7379L20.241 29.9495C20.1426 30.4286 19.719 30.7891 19.2108 30.7893C18.7024 30.7891 18.2772 30.4288 18.1789 29.9495L18.1577 29.7379V26.2288C18.1577 25.6475 18.6296 25.1759 19.2108 25.1757Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.2108 16.7545C19.7919 16.7547 20.2622 17.2263 20.2622 17.8075V21.3167L20.241 21.5282C20.1427 22.0075 19.7191 22.3679 19.2108 22.3681C18.7024 22.3679 18.2771 22.0076 18.1789 21.5282L18.1577 21.3167V17.8075C18.1577 17.2263 18.6296 16.7547 19.2108 16.7545Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.035 8.33325C29.6161 8.33348 30.0864 8.8051 30.0864 9.38631V19.912C30.0864 20.4932 29.6161 20.9649 29.035 20.9651C28.4539 20.9648 27.9819 20.4932 27.9819 19.912V9.38631C27.9819 8.80514 28.4539 8.33354 29.035 8.33325Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.2108 8.33325C19.7919 8.33348 20.2622 8.8051 20.2622 9.38631V12.8954L20.241 13.107C20.1428 13.5864 19.7191 13.9467 19.2108 13.9469C18.7022 13.9468 18.2771 13.5865 18.1789 13.107L18.1577 12.8954V9.38631C18.1577 8.80503 18.6295 8.33336 19.2108 8.33325Z",
    fill: "#BB8A1A"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_17415"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}